




























import {Component, Vue} from 'vue-property-decorator';
import ContentSection from '@/components/ContentSection.vue';
import {IContentSection} from '@/components/types';
import Modal from '@/components/Modal.vue';
import ContactBox from '@/components/ContactBox.vue';
import {TranslateResult} from 'vue-i18n';

@Component({
	components: {
		'v-content-section': ContentSection,
		'v-modal': Modal,
		'v-contact-box': ContactBox
	}
})
export default class Contact extends Vue {
	get content(): IContentSection {
		return {
			headline: this.$t('contact.headline') as string,
			perex: this.$t('contact.perex') as string
		}
	}

	get contacts(): TranslateResult {
		return this.$t('contact.items');
	}

}
